import React, { Component } from 'react';
import './Toasts.css';
import Label from '../label/Label';

export default class Toasts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: true,
			classes: '',
			text: ''
		};
		window.showToast = this.show;
	}
	show = (text, time = 2000) => {
		this.setState({ text, open: true, classes: '' }, () => {
			this.setState({ classes: 'open' });
		});
		setTimeout(() => {
			this.setState({ open: false, classes: '' });
		}, time);
	};

	render() {
		return (
			<div className={'g-toasts ' + this.state.classes}>
				<Label large white>
					{this.state.text}
				</Label>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/toasts/Toasts.jsx